<ca-conversation-standard-chat-list
    *ngIf="standardListVisible"
    (conversationIdChange)="onConversationIdChanged($event)"
    (dataLoaded)="onDataLoaded()"
></ca-conversation-standard-chat-list>
